import { forwardRef, useState, useRef } from 'react'
import { Transition } from 'react-transition-group'
import * as Styled from './styles'

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  isOpen?: boolean
  isDisabled: boolean
  isPlaceholder: boolean
  hasError: boolean
  hasWarning: boolean
  children: React.ReactNode
  icon?: JSX.Element
  useWhiteArrow?: boolean
  buttonOnClick?: () => void
}

type Ref = React.ForwardedRef<HTMLButtonElement>

export const SelectButton = forwardRef((props: Props, ref: Ref) => {
  const {
    isOpen,
    isDisabled,
    isPlaceholder,
    hasError,
    hasWarning,
    children,
    icon,
    useWhiteArrow,
    buttonOnClick,
    ...rest
  } = props
  const [isFocused, setFocused] = useState(false)
  const transitionRef = useRef(null)

  return (
    <Styled.Button
      ref={ref}
      $isOpen={isOpen}
      $isDisabled={isDisabled}
      $isPlaceholder={isPlaceholder}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      onClick={buttonOnClick}
      {...rest}
    >
      {icon && icon}

      {/* Displayed value */}
      {children}

      {/* Arrow icon */}
      <Styled.Icon $isOpen={isOpen} $isDisabled={isDisabled} $useWhite={!!useWhiteArrow} />

      {/* Animated bottom bar */}
      <Transition
        in={isOpen || isFocused || hasError || hasWarning}
        timeout={100}
        nodeRef={transitionRef}
      >
        {state => (
          <Styled.Bar
            state={state}
            isOpen={isOpen}
            hasError={hasError}
            hasWarning={hasWarning}
            ref={transitionRef}
          />
        )}
      </Transition>
    </Styled.Button>
  )
})
